var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let LoaderCard = class LoaderCard extends Vue {
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], LoaderCard.prototype, "title", void 0);
__decorate([
    Prop({ default: 'circle' }),
    __metadata("design:type", String)
], LoaderCard.prototype, "type", void 0);
__decorate([
    Prop({ default: 128 }),
    __metadata("design:type", Number)
], LoaderCard.prototype, "size", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], LoaderCard.prototype, "description", void 0);
LoaderCard = __decorate([
    Component({})
], LoaderCard);
export default LoaderCard;
